module.exports = __webpack_public_path__ + "media/application/images/icons/print-white-fd9d1ae04fe601de9411c62e1e150828.svg";